/**
 * Owner login-as creates a support-session user under
 * adsUsers/{agencyID}/{userID}. The backend sets ownerSupportGhost and an
 * email on this domain. isHidden is also set, but a hidden real user is not
 * a ghost.
 */
export const OWNER_SUPPORT_GHOST_EMAIL_SUFFIX = "@owner-support.adle.internal";

export const isOwnerSupportGhostEmail = (email) => {
  if (typeof email !== "string") return false;
  return email.trim().toLowerCase().endsWith(OWNER_SUPPORT_GHOST_EMAIL_SUFFIX);
};

/**
 * True for a support-session ghost. Accepts a user record or a raw email.
 * Filter with this before choosing the account's user.
 */
export const isOwnerSupportGhost = (userOrEmail) => {
  if (typeof userOrEmail === "string") {
    return isOwnerSupportGhostEmail(userOrEmail);
  }
  if (!userOrEmail || typeof userOrEmail !== "object") return false;
  if (userOrEmail.ownerSupportGhost === true) return true;
  return isOwnerSupportGhostEmail(userOrEmail.email);
};

/** Copies the backend flag when it is strictly true. */
export const readOwnerSupportGhostFlags = (userData) => {
  if (!userData || typeof userData !== "object") return {};
  if (userData.ownerSupportGhost === true) {
    return { ownerSupportGhost: true };
  }
  return {};
};

export const excludeOwnerSupportGhostUsers = (users) => {
  if (!Array.isArray(users)) return [];
  return users.filter((user) => !isOwnerSupportGhost(user));
};
